import { Observable } from "rxjs";
import { ConnectionState } from "./YourAppServer/YourAppServerSoket.service";
import { InHouseDataModel } from "../shared/models";
import Utils from "../shared/utils";

export enum ErrorCode {
  InternalError = 0
}

//#region Hub Models

/** Models */

/** Umbennenung der Kurzschreibweise zur vollen Beschreibung */
const _rename_POSTable = ({
  tn: tableNumber,
  gn: groupName,
  gc: groupCode,
  gp: groupUrlPrefix,
  it: items }): POSTable => ({
    tableNumber,
    groupName,
    groupCode,
    groupUrlPrefix,
    items
  });
const _rename_POSTable_Item = ({
  id: id,
  oi: orderId,
  pn: placeNumber,
  ut: userToken,
  od: orderdAt_YMD,
  ot: orderdAt_HMS,
  st: status,
  rd: readyAt_YMD,
  rt: readyAt_HMS,
  mc: menuCourse,
  am: amount,
  pi: productID,
  us: usingType,
  nd: name_de,
  ne: name_en,
  pr: price,
  op: orgprice,
  pe: PE,
  ft: FT,
  ih: IHAH,
  va: vat,
  vd: validDate_YMD,
  bi: bookInfo,
  di: discount,
  ex: extras }): POSTable_Item => ({
    id,
    orderId,
    placeNumber,
    userToken,
    orderdAt_YMD,
    orderdAt_HMS,
    status,
    readyAt_YMD,
    readyAt_HMS,
    menuCourse,
    amount,
    productID,
    usingType,
    name_de,
    name_en,
    price,
    orgprice,
    PE,
    FT,
    IHAH,
    vat,
    validDate_YMD,
    bookInfo,
    discount,
    extras
  });
const _rename_POSTable_Item_Extra = ({
  am: amount,
  pi: productID,
  nd: name_de,
  ne: name_en,
  pr: price,
  li: linked
}): POSTable_Item_Extra => ({
  amount,
  productID,
  name_de,
  name_en,
  price,
  linked
});
export const _renameFull_POSTable = (obj: any): POSTable => {
  const table = _rename_POSTable(obj);
  if (table.items) {
    const items = table.items;
    for (let i = 0; i < items.length; ++i) {
      items[i] = _rename_POSTable_Item(<any>items[i]);
      if (items[i].extras) {
        const extras = items[i].extras;
        for (let e = 0; e < extras.length; ++e) {
          extras[e] = _rename_POSTable_Item_Extra(<any>extras[e]);
        }
      }
    }
  }
  return table;
}

/** Table/Vorgang (Bestellung ist aber vorhanden sobald ein Gast am Tisch platz nimmt und Anfängt sein Warenkorb zu befüllen) */
export class POSTable {
  /** Tischnummer z.B. "1", "1234" usw. */
  tableNumber: string;
  /** Gruppenname */
  groupName: string;
  /** Gruppen Code für den QR-Code */
  groupCode: string;
  /** Gruppen URL Prefix für den QR-Code "{groupUrlPrefix}+{groupCode}" (Limit für alles ist 143 Zeichen) */
  groupUrlPrefix: string;
  /** Artikel - Bestellpositionen */
  items: POSTable_Item[];
}

/** Momentaner Zubereitungsstatus des Artikels */
export enum POSTable_ItemStatus {
  /** Noch nicht gesetzt */
  Unknown = 0,
  /** Bestellt */
  Orderd = 10,
  /** In Zubereitung */
  Preparing = 20,
  /** Abhol Bereit */
  PickUpReady = 30,
  /** Abgeholt */
  Complete = 40,
  /** Ohne Zubereitung */
  NoPreparation = 50,
  /** Wird Gebracht */
  TableService = 60
}

/** Artikel */
export class POSTable_Item {
  /** generierte ID pro Artikel im Vorgang (RecordPosition aus .TIS Datei) */
  id: number;
  /** generierte ID pro Bestellungs im Vorgang, um Bestellungen auseinander zu halten */
  orderId: number;
  /** redundant mit customer um die Zuordnung eines Artikels zu einem Customernmamen tätigen zu können */
  placeNumber: number;
  /** Customer welcher den Artikel ausgewählt hat */
  userToken: string;
  /** vorgang geöffnet zum zeitpunkt (Date) */
  orderdAt_YMD: number;
  /** vorgang geöffnet zum zeitpunkt (Time) */
  orderdAt_HMS: number;
  /** Zubereitungsstatus */
  status: POSTable_ItemStatus;
  /** abhol bereit seit zeitpunkt (Date) */
  readyAt_YMD: number;
  /** abhol bereit seit zeitpunkt (Time) */
  readyAt_HMS: number;
  /** Menügang */
  menuCourse: number;
  /** Anzahl der Artikel */
  amount: number;
  /** ProductID (vom POS) */
  productID: number;
  /** UsingType - Art des Artikels (vom POS) */
  usingType: number;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. de */
  name_de: string;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. en */
  name_en: string;
  /** Einzelpreis (rabattiert) in Cent */
  price: number;
  /** Originalpreis (ohne Rabatte) in Cent */
  orgprice: number;
  /** Preisebene */
  PE: number;
  /** Kommentar */
  FT: string;
  /** könnte evtl. eine Buchung zum Mitnehmen bedeuten. Sollten wir somit vorerst beibehalten. */
  IHAH: "IH" | "AH";
  /** MwSt Satz * 100 (bsp. 6,5% -> 650) */
  vat: number;
  /** Gültigeitsdatum (Date), z.B. bei Tickets */
  validDate_YMD: number;
  /** wird nur genutzt um die neue Webgutscheinnummer zu übergeben, z.B. 49010123456781 */
  bookInfo: string;
  /** Kunden- oder Webgutschein-Rabattsatz * 100 (bsp. 6,5% -> 650) */
  discount: number;
  /** Extras */
  extras: POSTable_Item_Extra[];
}

/** Extra als Auswahl zum Artikel */
export class POSTable_Item_Extra {
  /** Anzahl der Artikel */
  amount: number;
  /** ProductID (vom POS) */
  productID: number;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. de */
  name_de: string;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. en */
  name_en: string;
  /** Einzelpreis in Cent */
  price: number;
  /** RezID als verlinkung zu weiteren Abfragen (wenn gesetzt ist es eine Unterabfrage) */
  linked: number;
}

const _rename_YASTable = ({
  lo: locked,
  cu: customers,
  pa: payments,
  ub: user_basket_items,
  gb: group_basket_items
}): YASTable => ({
  locked,
  customers,
  payments,
  user_basket_items,
  group_basket_items
});
const _rename_YASTable_Payment = ({
  st: status,
  ut: userToken,
  am: amount,
  sc: serviceCharge,
  it: items
}): Payment => ({
  status,
  userToken,
  amount,
  serviceCharge,
  items
});
export const _renameFull_YASTable = (obj: any): YASTable => {
  const table = _rename_YASTable(obj);
  if (table.payments) {
    const payments = table.payments;
    for (let p = 0; p < payments.length; ++p) {
      payments[p] = _rename_YASTable_Payment(<any>payments[p]);
    }
  }
  return table;
}

/** Table/Vorgang (Bestellung ist aber vorhanden sobald ein Gast am Tisch platz nimmt und Anfängt sein Warenkorb zu befüllen) */
export class YASTable {
  /** Tisch wurde am POS gesperrt (keine Zahlung in YourAPP wenn locked) */
  locked: boolean;
  /** Kunden (Gäste) am Tisch */
  customers: Customer[];
  /** laufende Zahlungen */
  payments: Payment[];
  /** Warenkorb Artikel - in der Auswahl (localer Warenkorb in der YourAPP) */
  user_basket_items: BasketItem[];
  /** Warenkorb Artikel - in dem Gruppen Warenkorb (vorbereitet zum Bestellen) */
  group_basket_items: BasketItem[];
}

/** Momentaner zusand des Payments */
export enum PaymentStatus {
  /** Gast ist dabei die Artikel für die Zahlung zusammen zu stellen. */
  Selecting = 0,
  /** Gast hat die Zahlung begonnen. */
  Paying = 1,
  /** Zahlung wurde erfolgreich verarbeitet und muss ans POS übergeben werden. */
  Complete = 2
}

/** laufende Zahlung */
export class Payment {
  /** Status vom Payment ist wichtig für YourAPP und YAS zur Zahlung */
  status: PaymentStatus;
  /** Customer Referenz */
  userToken: string;
  /** Betrag (+serviceCharge) in in Cent */
  amount: number;
  /** Trinkgeld (amount) in Cent */
  serviceCharge: number;
  /** Artikel - Zubezahlende Artikel */
  items: PaymentItem[];
}

/** Artikel die bezahlt werden */
export class PaymentItem {
  /** Id der POSTable.Item.ID */
  id: number;
  /** Anzahl der Artikel */
  amount: number;
  /** ProductID der POSTable.Item.ProductID */
  prod_id: number;
}

/** Benachrichtigungsart */
export enum NotificationTyp {
  /** Keine Benachrichtigung */
  NONE = 0,
  /** Per WebPush */
  WebPush = 1,
  /** Per SMS */
  SMS = 2,
  /** Per FCM (Firebase Cloud Messaging) */
  FCM = 3,
}

/** Kunde (Gast) mit Sitzplatz */
export class Customer {
  /** Identifikation des Gastes am Tisch (Eindeutig im [Standort] am [TTADate] über [Tische] und [Plätze]) */
  user_token: string;
  /** Platz am Tisch */
  place_no: number;
  /** Nickname (kann vom echten namen abweichen und wird zur Anzeige genutzt, z.B. auch am POS/mPOS) */
  nickname: string;
  /** Ist ein Gast und nicht Customer aus Kundenstamm 2.0 (auch keine AccountID/Kundennummer) */
  guest: boolean;
  /** Benachrichtigungsart */
  notification_typ: NotificationTyp;
  /** "Abhol bereit" Status wurde vom Gast bemerkt */
  noticed_items: number[];
  /** Wenn der Gast artikel in sein Warenkorb legt, bekommt er den status, dass er gerade bestellt */
  is_ordering: boolean;
  /** Anrede */
  prefix: string;
  /** Nachname */
  name: string;
  /** Vorname */
  fname: string;
  /** E-Mail */
  email: string;
  /** Geburtstag */
  bday: number;
  /** Rechnungsadresse */
  address: CustomerAddress;
}

/** Kunden Adresse */
export class CustomerAddress {
  /** enthält z. B. Company */
  co: string;
  /** Straße */
  street: string;
  /** Zusatz */
  addition: string;
  /** PLZ */
  zip: string;
  /** Stadt */
  city: string;
  /** Land */
  country: string;
}

/** Warenkorb Artikel */
export class BasketItem {
  /** Customer welcher den Artikel ausgewählt hat */
  user_token: string;
  /** redundant mit userToken nur zur sicherheit */
  place_number: number;
  /** Position im Warenkorb zur identifikation (wird durch YourAPP vergeben, um Warenkorb über Differenzen abgleichen zu können) */
  position: number;
  /** Menügang */
  menu_course: number;
  /** Anzahl der Artikel */
  amount: number;
  /** ProductID (vom POS) */
  product_id: number;
  /** UsingType - Art des Artikels (vom POS) */
  usingType: number;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. de */
  name_de: string;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. en */
  name_en: string;
  /** Einzelpreis in Cent */
  price: number;
  /** Originalpreis (Einzelpreis bei Anwendung von Rabatten) in Cent */
  orgprice: number;
  /** Preisebene */
  pe: number;
  /** Kommentar */
  freetext: string;
  /** könnte evtl. eine Buchung zum Mitnehmen bedeuten. Sollten wir somit vorerst beibehalten. ["IH"/"AH"] */
  ihah: "IH" | "AH";
  /** MwSt Satz * 100 (bsp. 6,5% -> 650) */
  vat: number;
  /** Gültigeitsdatum (Date), z.B. bei Tickets */
  validDate_YMD: number;
  /** wird nur genutzt um die neue Webgutscheinnummer zu übergeben, z.B. 49010123456781 */
  book_info: string;
  /** Kunden- oder Webgutschein-Rabattsatz * 100 (bsp. 6,5% -> 650) */
  discount: number;
  /** Extras */
  extras: BasketItemExtra[];
}

/** Extra als Auswahl zum Artikel */
export class BasketItemExtra {
  /** Anzahl der Artikel */
  amount: number;
  /** ProductID (vom POS) */
  product_id: number;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. de */
  name_de: string;
  /** Artikelbezeichnung, nur wenn die YAS den Artikel nicht kennt, sonst aus ProductID. en */
  name_en: string;
  /** Einzelpreis in Cent */
  price: number;
  /** RezID als verlinkung zu weiteren Abfragen (wenn gesetzt ist es eine Unterabfrage) */
  linked: number;
}

/** Typ der Tischänderung */
export enum TableChangedType {
  /** gesamter Tisch, bzw, es konnte nicht festgestellt welche änderung es genau gab */
  All = 0,
  /** Lock Status des Tisches wurde geändert. */
  Lock = 1,
  /** Gäste am Tisch wurden verändert. */
  Customer = 2,
  /** Gebuchte Artikel wurden verändert. */
  Items = 4,
  /** Zahlungs status wurde verändert. Besonders bei der Zahlungsauswahl. */
  Payment = 8,
  /** Freie Option zur späteren nutzung. */
  FREESLOT_1 = 16,
  /** Freie Option zur späteren nutzung.*/
  FREESLOT_2 = 32,
  /** Freie Option zur späteren nutzung. */
  FREESLOT_3 = 64,
  /** Tisch wurde geschlossen. Kommt als ALL_CLOSED.  */
  Closed = 128,
  /** Alle Eigenschaften werden ausgelöst, da der Tisch geschlossen wurde. */
  ALL_CLOSED = 255 /* 255 änthält alle kleiner gleich 128 auser 0 */
}

/** Art der Benachrichtigung */
export enum MessageType {
  /** Nachricht vom POS */
  POSMessage = 0,
}

/* InHouseOrder Server Function Calls (siehe YourAPPServerClient.Models.YASC ) */

/** Returnwert für Funktion GetStatus */
export class res_GetStatus {
  /** Serveruhrzeit (Date) */
  server_time_YMD: number;
  /** Serveruhrzeit (Time) */
  server_time_HMS: number;
  /** Ist ein POS momentan verbunden */
  has_pos_connection: boolean;
  /** Tischnummer, wenn hinterlegt */
  table_no: string;
  /** Gruppenbezeichnung, wenn hinterlegt */
  group_name: string;
  /** Gast Daten, wenn hinterlegt */
  customer: Customer;
}

/** Parameter für Funktion UpdateCustomer */
export class req_UpdateCustomer {
  /** Gast Daten, welche aktualisiert werden */
  customer: Customer;
}

/** Status ob UpdateCustomer Funktioniert hat */
export enum UpdateCustomerStatus {
  /** Aktualisierung der Gast Daten war erfolgreich */
  Okay = 0,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion UpdateCustomer */
export class res_UpdateCustomer {
  /** Status ob die Aktualisierung der Gast Daten erfolgrich war */
  status: UpdateCustomerStatus;
}

/** Welche Daten beim Tisch vorhanden sein sollen. (Eingeschränkte daten reduzieren den Abruf aufwand) */
export enum TableData {
  /** Gesamter Tisch */
  All = 1,
  /** Gast Warenkorb */
  MyBasked = 2,
  /** Gruppenwarenkorb */
  GroupBasked = 3,
  /** Gebuchte Artikel */
  OrderdItems = 4,
  /** Artikel und der Status vom Payment */
  PayStatus = 5,
  /** Gäste */
  Customers = 6,
  /** Ob der Tisch vom POS gesperrt ist */
  Locked = 7,
}

/** Art der Änderung, Voll oder Diffirenziel */
export enum BasketChangeType {
  /** Voller Abgleich */
  Full = 0,
  /** Diffirinzieller Abgleich */
  Diff = 1,
}
/** Parameter für Funktion ChangeBasket */
export class req_ChangeBasket {
  /** Status ob die Änderung des Warenkorbs differenziel oder voll sind */
  change_type: BasketChangeType;
  /** Als antwort erhält es den gesamten Warenkorb */
  return_items: boolean;
  /** Artikel die im Warenkorb verändert wurden (differenz Warenkorb) */
  items: BasketItem[];
}

/** Status ob ChangeBasket Funktioniert hat */
export enum ChangeBasketStatus {
  /** Änderung am Warenkorb war erfolgreich */
  Okay = 0,
  /** Änderung am Warenkorb war nicht möglich */
  Fail = 1,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion ChangeBasket */
export class res_ChangeBasket {
  /** Status ob die Änderung des Warenkorbs erfolgrich war */
  status: ChangeBasketStatus;
  /** Artikel die im Warenkorb verändert wurden (gesamter Warenkorb) */
  items: BasketItem[];
}

/** Status ob MoveToGroupBasket Funktioniert hat */
export enum MoveToGroupBasketStatus {
  /** Warenkorb konnte erfolgreich umgelegt werden */
  Okay = 0,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion MoveToGroupBasket */
export class res_MoveToGroupBasket {
  /** Status ob die Bestellung erfolgreich war */
  status: MoveToGroupBasketStatus;
}

/** Art der Änderung, Voll oder Diffirenziel */
export enum ChangeGroupBasketChangeType {
  /** Voller Abgleich */
  Full = 0,
  /** Diffirinzieller Abgleich */
  Diff = 1,
}
/** Parameter für Funktion ChangeGroupBasket */
export class req_ChangeGroupBasket {
  /** Status ob die Änderung des Warenkorbs differenziel oder voll sind */
  change_type: ChangeGroupBasketChangeType;
  /** Als antwort erhält es den gesamten Warenkorb */
  return_items: boolean;
  /**Artikel die im Warenkorb verändert wurden (differenz Warenkorb)  */
  items: BasketItem[];
}
/** Status ob ChangeBasket Funktioniert hat */
export enum ChangeGroupBasketStatus {
  /** Änderung am Warenkorb war erfolgreich */
  Okay = 0,
  /** Änderung am Warenkorb war nicht möglich */
  Fail = 1,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion ChangeGroupBasket */
export class res_ChangeGroupBasket {
  /** Status ob die Änderung des Warenkorbs erfolgreich war */
  status: ChangeGroupBasketStatus;
  /** Artikel die im Warenkorb verändert wurden (gesamter Warenkorb) */
  items: BasketItem[];
}

/** Art der Bestellung */
export enum OrderType {
  /** Warenkorb des Gastes selbst */
  UserBasket = 0,
  /** Gruppen Warenkorb */
  GroupBasket = 1,
}
/** Parameter für Funktion Order */
export class req_Order {
  /** Art der Bestellung */
  order_type: OrderType;
}

/** Status ob Order Funktioniert hat */
export enum OrderStatus {
  /** Order/Bestellung wurde erfolgreich verarbeitet */
  Okay = 0,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion Order */
export class res_Order {
  /** Status ob die Bestellung erfolgrich war */
  status: OrderStatus;
}

/** Status ob ChangeBasket Funktioniert hat */
export enum StartPaymentSelectStatus {
  /** Artikel Zahlungs Auswahl wurde erfolgreich begonnen */
  Okay = 0,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion StartPaymentSelect */
export class res_StartPaymentSelect {
  /** Status ob die Änderung des Warenkorbs erfolgrich war */
  status: StartPaymentSelectStatus;
}

/** Art der Änderung, Voll oder Diffirenziel */
export enum ChangePaymentSelectChangeType {
  /** Voller Abgleich */
  Full = 0,
  /** Diffirinzieller Abgleich */
  Diff = 1,
}
/** Parameter für Funktion ChangePaymentSelect */
export class req_ChangePaymentSelect {
  /** Status ob die Änderung der Zahlungs Auswahl differenziel oder voll sind */
  change_type: ChangePaymentSelectChangeType;
  /** Als Antwort erhält es den gesamte Auswahl */
  return_items: boolean;
  /** Artikel die zur Zahlung ausgewählt wurden (differenz, bei negativem amount wird abgewählt) */
  items: PaymentItem[];
}

/** Status ob ChangeBasket Funktioniert hat */
export enum ChangePaymentSelectStatus {
  /** Änderung am Warenkorb war erfolgreich */
  Okay = 0,
  /** Änderung am Warenkorb war nicht möglich */
  Fail = 1,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion ChangePaymentSelect */
export class res_ChangePaymentSelect {
  /** Status ob die Änderung des Warenkorbs erfolgrich war */
  status: ChangePaymentSelectStatus;
  /** Ausgewählte Artikel, wenn return_items=true angefragt wurde. */
  items: PaymentItem[];
}

/** Status ob AbortPaymentSelect Funktioniert hat */
export enum AbortPaymentSelectStatus {
  /** Artikel Zahlungs Auswahl wurde abgebrochen */
  Okay = 0,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion AbortPaymentSelect */
export class res_AbortPaymentSelect {
  /** Status ob das Beenden der Artikel Zahlungs Auswahl erfolgrich war */
  status: AbortPaymentSelectStatus;
}

/** Parameter für Funktion ServiceCall */
export class req_ServiceCall { //todo intent nicht extern
  /** Serviceruf Nachricht */
  message: string;
}

/** Status ob ServiceCall Funktioniert hat */
export enum ServiceCallStatus { //todo intent nicht extern
  /** Serviceruf wurde erfolgreich verarbeitet */
  Okay = 0,
  /** Serviceruf konnte nicht verarbeitet werden */
  Fail = 1,
  /** Fehler beim verarbeiten */
  Error = -1,
}
/** Returnwert für Funktion ServiceCall */
export class res_ServiceCall {
  /** Status ob ServiceCall Funktioniert hat */
  status: ServiceCallStatus;
}

//#endregion

// sonstige typen

/** Darstellung der Plätze mit Bestellen Artikeln nach Gästen */
export type Seats = { [userToken: string]: { customer: Customer, pos_items: POSTable_Item[] } };

export enum GetPlaceStatus {
  /** User an Platz zu setzen war erfolgrich */
  Okay = 0,
  /** User an Platz zu setzen war nicht möglich */
  Fail = 1,
  /** Username ist falsch, vergeben oder gesterrt */
  WrongUserName = 2,
  /** Gruppenname ist falsch, vergeben oder gesterrt */
  WrongGroupName = 3,
  /** User konnte Gruppe nicht beitreten, Gruppe hat das Limit erreicht */
  GroupFull = 4,
  /** Gruppe konnte nicht erzeugt werden, Tisch hat das Limit erreicht */
  TableFull = 5,
  /** Fehler beim verarbeiten */
  Error = -1,
}

/** Returnwert vom SetTable */
export class SetTableDone {
  /** SetTable war erfolgreich */
  success: boolean = false;
  /** GetPlaceStatus, wenn nicht success */
  status: GetPlaceStatus = GetPlaceStatus.Error;
  /** Tisch information, wenn success */
  table_info: TableInfo = null;
}

export class Table {
  /** POS Tisch Daten */
  posTable: POSTable;
  /** YourAppServer Tisch Daten */
  yasTable: YASTable;
};

/** tisch kurz info für die Oberfläche (place_no != 0 > hat platz am Tisch) */
export interface IUiData {
  /** Tischnummer */
  readonly table_no: string;
  /** Sitzplatz am Tisch */
  readonly place_no: number;
  /** Gruppenname */
  readonly group_name: string;
  /** Gruppencode */
  readonly group_code: string;
  /** Ist es eine Gruppenbestellung */
  readonly isGroup: boolean;
  /** Gast Nickname */
  readonly user_nickname: string;
  /** Anzahl an Gästen am Tisch / in der Gruppe */
  readonly customer_count: number;
  /** Unbezahlte Artikel am Tisch */
  readonly open_amount: number;
  /** Offener Betrag am Tisch */
  readonly open_price: number;
}

/** tisch kurz info.
 * Achtung: es darf keine referenzen verwenden, da es kopiert wird
 */
export class TableInfo implements IUiData {
  /** Tischnummer */
  table_no: string = "";
  /** Sitzplatz am Tisch */
  place_no: number = 0;
  /** Gast Nickname */
  user_nickname: string = "";
  /** Gruppenname */
  group_name: string = "";
  /** Gruppencode */
  group_code: string = "";
  /** Ist es eine Gruppenbestellung */
  public get isGroup(): boolean {
    return !Utils.IsNullOrEmpty(this.group_code);
  }
  /** Anzahl an Gästen am Tisch / in der Gruppe */
  customer_count: number = 0;
  /** Unbezahlte Artikel am Tisch */
  open_amount: number = 0;
  /** Offener Betrag am Tisch */
  open_price: number = 0;
}

/** Representation von Tisch informationen zum QRCode */
export interface ITableQRCode {
  /** Tisch Code als QRCode */
  readonly qrCode: string;
  /** Standort im QRCode */
  readonly location: number;
  /** Tisch Bezeichnung im QRCode */
  readonly tableName: string;
  /** Tischnummer im QRCode */
  readonly tableNr: string;
  /** muss sofort bezahlt werden*/
  readonly mandatory_Payment: boolean;
}

export interface IInHouseOrderService {

  /** Verbindung wurde geschlossen */
  readonly ObserveClosed: Observable<void>;

  /** momentan die Möglichkeit auf dem BezahlbestätigungsScreen die Warnung über geschlossenen tisch zu unterdrücken */
  suppressNextTableClosedWarning: boolean;

  /** Wird aufgerufen wenn es erfolgreich wieder Verbunden wurde nach einem Timeout. */
  readonly ObserveUiDataChanged: Observable<IUiData>;

  /** Für Oberfläche (wie navigtion oder homescreen) relevenate daten */
  readonly UiData: IUiData;

  /** Ermittelt den momentanen Connection Status */
  readonly Status: ConnectionState;

  /** Aktueller Tisch Code */
  readonly TableData: ITableQRCode;

  /** Aktuelle Gruppen Bezeichnung */
  readonly GroupName: string;

  /** Aktueller Gruppen Code */
  readonly GroupCode: string;

  /** Aktueller User Nickname */
  readonly UserNickname: string;

  /** Aktueller User Token */
  readonly UserToken: string;

  /** Aktuelle Platznummer */
  readonly PlaceNo: number,

  /** verläst tisch und beendet die offene verbindung */
  leaveTable(showConnectionLostDialog: boolean): Promise<void>;

  /** pausiert die offene SignalR verbindung. Sollte aufgerufen werden wenn die Seite suspandet wird */
  Pause(): void;

  /** reaktiviert die offene SignalR verbindung. Sollte aufgerufen werden wenn die Seite suspandet wird */
  Resume(): void;

  /* Sollte durch ein Intent ausgelöst werden, welcher Extern ausgelöst wird */
  onExternIntent(url: string): Promise<void>;

  /** Navigieren zur Landingpage vom InHouseOrder */
  openInHauseLandingPage(): Promise<void>;

  /** Stellt eine Verbindung zum Standort YourAppServer her */
  Connect(location: number): Promise<void>;

  /** Trennt die offne Verbindung */
  Disconnect(cleanup: boolean): Promise<void>;

  /** Synchronisiert SignalR mit Owin auf dem Server */
  SyncConnectionWithServer(): Promise<boolean>;
  /** Ermittelt vom Server ob InHouse eine Zahlungsart hat */
  HasPaymentOnServer(): Promise<boolean>;

  /** Versucht aus dem Speicher den Gast erneut an den Tisch zu setzen, wenn es scheitert wird null returnt */
  TryGetBackToStoredTableOrGroup(): Promise<SetTableDone>;

  /** Wird beim Scannen von Tischcode aufgerufen.
   * Wenn need_new_scan=true zurückkommt, muss der TischCode Erneut gescannt werden, bestehenden nicht mehr verwenden.
   * @param tableQRCode Tisch QR Code
   * @param groupName Gruppenname
   * @param nickname Gast Nickname
   */
  SetTableCode(tableQRCode: string, groupName: string, nickname: string): Promise<SetTableDone>;

  /** Ermittelt vom aktuellen tisch bzw eine bestimmte information */
  GetTable(table_data: TableData | null): Promise<Table>;

  /** Ermitlung der Plätze mit Bestellen Artikeln nach Gästen vom Tisch */
  GetSeatsFromTable(table: Table): Seats;

  /** generiert ein InHouseDataModel für die Communikation mit dem Server */
  GetInHouseDataModelForCheckout(): InHouseDataModel;

  /** Informiert bei Änderung vom Tisch ein YourAppClient */
  readonly ObserveOnTableChanged: Observable<TableChangedType>;

  /** Informiert beim Schließen vom Tisch */
  readonly ObserveOnTableClosedChanged: Observable<{ tableData: ITableQRCode, groupName: string, groupCode: string, placeNo: number, userNickname: string, userToken: string, table: Table }>;

  /** Artikel Zahlungs Auswahl wurde abgebrochen */
  readonly ObserveOnPaymentSelectAborted: Observable<void>;

  /** Eingehende Nachricht vom POS */
  readonly ObserveOnNotification: Observable<{ type: MessageType, message: string }>;

  /** Ermittelt den Status bei der Connection. z.B. Ob ein POS die Anfragen verarbeitet. */
  GetStatus(): Promise<res_GetStatus>;

  /** Aktualisiert die Customer Daten. Es darf nur nach GetPlace verwendet werden und res_SetCustomer muss req_GetPlace entsprechen. */
  UpdateCustomer(param: req_UpdateCustomer): Promise<res_UpdateCustomer>;

  /** Wird Aufgerufen, um die Info zur regestrierten Notification abzufragen */
  GetNotificationInfo(): Promise<string>;

  /** Wird Aufgerufen, um Artikel im Warenkorb zu verändern */
  ChangeBasket(param: req_ChangeBasket): Promise<res_ChangeBasket>;

  /** Überträgt die Artikel aus dem UserBasket in den GroupBasket */
  MoveToGroupBasket(): Promise<res_MoveToGroupBasket>;

  /** Wird Aufgerufen, um Artikel im Gruppen Warenkorb zu verändern */
  ChangeGroupBasket(param: req_ChangeGroupBasket): Promise<res_ChangeGroupBasket>;

  /** Wird Aufgerufen, Artikel über das POS Bestellt werden */
  Order(param: req_Order): Promise<res_Order>;

  /** Wird Aufgerufen, Wenn der User seine Artikel als Bemerkt markieren möchte */
  ItemsNoticed(items: number[]): Promise<boolean>;

  /** Wird Aufgerufen, um die Artikel Zahlungs Auswahl zu beginnen, Bei abbruch muss AbortPaymentSelect aufegrufen werden. */
  StartPaymentSelect(): Promise<res_StartPaymentSelect>;

  /** Wird Aufgerufen, um die Artikel Zahlungs Auswahl zu verändern */
  ChangePaymentSelect(param: req_ChangePaymentSelect): Promise<res_ChangePaymentSelect>;

  /** Wird Aufgerufen, um die Artikel Zahlungs Auswahl zu abzubrechen.
   * Soll nicht aufgerufen werden, wenn eine Zahlung durchgeführt werden. */
  AbortPaymentSelect(): Promise<res_AbortPaymentSelect>;

  /** Wird Aufgerufen, um ein ServiceRuf am POS auszulösen */
  ServiceCall(param: req_ServiceCall): Promise<res_ServiceCall>;
}
